import type { FocusEvent } from 'react';
import { useState } from 'react';
import { useProperty, useSnowplowTracking, useTranslation } from '@eti/providers';
import { ConnectedInput } from '@eti/form';
import { constants, persistInputData } from '@eti/utils';
import { TRAVELER_DETAILS } from '../../../../constants/formNamesConstants';
import { contactFields, fieldRestrictions } from '../../constants/formFields';

const { MOUSE_FLOW_CLASS_NAMES } = constants;

const LastName = () => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();
  const [hasChanged, setHasChanged] = useState(false);

  const handleOnChange = () => {
    if (isSnowplowTrackingEnabled && !hasChanged) {
      sendTrackEvent({
        category: 'Traveler Details',
        action: 'Input',
        label: 'Emergency-surname',
      });
      setHasChanged(true);
    }
  };

  const handleOnBlur = p('IbeClient.TravelerDetails.PersistFormData.Enabled')
    ? (event: FocusEvent<HTMLInputElement>) =>
        persistInputData(TRAVELER_DETAILS, contactFields.EMERGENCY_LAST_NAME)(event.target.value)
    : undefined;

  return (
    <ConnectedInput
      autoCapitalize="on"
      autoComplete="family-name"
      autoCorrect="off"
      className={MOUSE_FLOW_CLASS_NAMES}
      data-testid="traveler-emergency-last-name-input"
      label={t('ContactForm.EmergencyContact.LastName.Label')}
      maxLength={fieldRestrictions.MAX_CHARS_LAST_NAME}
      name={contactFields.EMERGENCY_LAST_NAME}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      placeholder={t('ContactForm.EmergencyContact.LastName.Placeholder')}
      shouldForceCapitalize={p('BookingFlow.Inputs.Capitalize.Enabled')}
      shouldMarkInputAsRequired
      spellCheck="false"
      type="text"
      validationRuleName={contactFields.EMERGENCY_LAST_NAME}
    />
  );
};

export default LastName;
